module.exports = __webpack_public_path__ + "static/img/main-02.a06eef2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/main-02.jpg
// module id = 6BX5
// module chunks = 1